/**
 * @param {function} func 函数
 * @param {number} wait 延迟时间
 * @description 防抖函数
 */
let debounce = function(func, wait) {
    var timer;
    return function() {
        if (timer) clearTimeout(timer);
        var context = this;
        var arg = arguments;
        timer = window.setTimeout(function() {
            func.apply(context, arg);
        }, wait);
    };
};

/**
 * @description 获取倒计时函数
 */
let getcountDonwFn = () => {
    let timeId = null;
    return (seconds, cb, wait = 1000) => {
        window.clearInterval(timeId);
        if (seconds <= 0 || Number.isNaN(seconds)) {
            cb && cb.call(this, 0);
            return;
        }
        cb && cb.call(this, seconds);
        timeId = window.setInterval(function() {
            seconds--;
            cb && cb.call(this, seconds);
            if (seconds <= 0) {
                window.clearInterval(timeId);
            }
        }, wait);
    };
};

/**
 * @param {number} seconds 秒数
 * @param {function} cb
 * @param {number} wait 倒计时间隔时间
 * @description 倒计时
 */
let countDown = getcountDonwFn();

/**
 *  @description 给数据增加选中状态
 */
let addSelectStatus = (dataSource) => {
    if (!Array.isArray(dataSource)) return [];
    let selectStatus = false;
    let temp = [];
    dataSource.forEach((item, index) => {
        temp.push(
            Object.assign(item, {
                selectStatus,
            })
        );
    });
    return temp;
};

/**
 * @description 精准加减乘除
 */
let calc = {
    /**
     *
     * @param {number} arg1 数字1
     * @param {bumber} arg2 数字2
     * @param {number} d 保留几位小数
     * @returns {number} 相加结果
     * @description 加法函数，用来得到精确的加法结果
     */
    Add: function(arg1, arg2) {
        (arg1 = arg1.toString()), (arg2 = arg2.toString());
        var arg1Arr = arg1.split("."),
            arg2Arr = arg2.split("."),
            d1 = arg1Arr.length == 2 ? arg1Arr[1] : "",
            d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
        var maxLen = Math.max(d1.length, d2.length);
        var m = Math.pow(10, maxLen);
        var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
        var d = arguments[2];
        return typeof d === "number" ? Number(result.toFixed(d)) : result;
    },
    /**
     *
     * @param {number} arg1 数字1
     * @param {bumber} arg2 数字2
     * @param {number} d 保留几位小数
     * @returns {number} 相减结果
     * @description 减法函数，用来得到精确的减法结果
     */
    Sub: function(arg1, arg2) {
        return calc.Add(arg1, -Number(arg2), arguments[2]);
    },
    /**
     *
     * @param {number} arg1 数字1
     * @param {bumber} arg2 数字2
     * @param {number} d 保留几位小数
     * @returns {number} 乘法结果
     * @description 乘法函数，用来得到精确的乘法结果
     */
    Mul: function(arg1, arg2) {
        var r1 = arg1.toString(),
            r2 = arg2.toString(),
            m,
            resultVal,
            d = arguments[2];
        m =
            (r1.split(".")[1] ? r1.split(".")[1].length : 0) +
            (r2.split(".")[1] ? r2.split(".")[1].length : 0);
        resultVal =
            (Number(r1.replace(".", "")) * Number(r2.replace(".", ""))) /
            Math.pow(10, m);
        return typeof d !== "number"
            ? Number(resultVal)
            : Number(resultVal.toFixed(parseInt(d)));
    },
    /**
     *
     * @param {number} arg1 数字1
     * @param {bumber} arg2 数字2
     * @param {number} d 保留几位小数
     * @returns {number} 除法结果
     * @description 除法函数，用来得到精确的除法结果
     */
    Div: function(arg1, arg2) {
        var r1 = arg1.toString(),
            r2 = arg2.toString(),
            m,
            resultVal,
            d = arguments[2];
        m =
            (r2.split(".")[1] ? r2.split(".")[1].length : 0) -
            (r1.split(".")[1] ? r1.split(".")[1].length : 0);
        resultVal =
            (Number(r1.replace(".", "")) / Number(r2.replace(".", ""))) *
            Math.pow(10, m);
        return typeof d !== "number"
            ? Number(resultVal)
            : Number(resultVal.toFixed(parseInt(d)));
    },
};

/**
 * @description 获取区间价格最合适的价格
 * @param {Array} priceRange 区间价格
 * @param {number}  pcs 当前购买的pcs
 */
let getPriceRange = (priceRange, pcs) => {
    var currentPrice = 0;
    var maxLen = priceRange.length - 1;
    for (var i = 0; i < priceRange.length; i++) {
        var curentRange = priceRange[i];
        var nextRange = priceRange[i + 1];
        if (pcs < parseInt(curentRange.qtyStart)) {
            if (i == 0) {
                currentPrice = curentRange.price;
                break;
            }
        } else if (pcs > parseInt(curentRange.qtyStart)) {
            if (i == maxLen) {
                currentPrice = curentRange.price;
                break;
            } else if (pcs < parseInt(nextRange.qtyStart)) {
                currentPrice = curentRange.price;
                break;
            }
        } else if (pcs == parseInt(curentRange.qtyStart)) {
            currentPrice = curentRange.price;
            break;
        }
    }
    return currentPrice;
};

/**
 *
 *
 *
 * @param {array} [priceRange=[]]
 * @param {number} [currentPrice=0]
 * @description 获取当前价格下标
 */
let getRangePriceIndex = (priceRange = [], currentPrice = 0) => {
    if (!Array.isArray(priceRange) || priceRange.length === 0) return 0;
    let index = -1;
    priceRange.forEach((item, i) => {
        let { price } = item;
        if (price == currentPrice) {
            index = i;
        }
    });
    return index;
};

/**
 * @param {number} pcs 当前pcs
 * @param {number} minPurchase 最小起购数
 * @param {number} stockPcs 库存数量
 * @description 修正pcs
 */
let correctedPcs = (pcs, minPurchase, stockPcs) => {
    var isCorrecte = pcs % minPurchase == 0 ? false : true;
    if (!isCorrecte) {
        return {
            isCorrecte: isCorrecte,
            pcs: pcs,
        };
    } else {
        var upwardPcs = calc.Mul(
            Math.ceil(calc.Div(pcs, minPurchase)),
            minPurchase
        );
        var downwardPcs = calc.Mul(
            Math.floor(calc.Div(pcs, minPurchase)),
            minPurchase
        );
        return {
            isCorrecte: isCorrecte,
            pcs: upwardPcs > stockPcs ? downwardPcs : upwardPcs,
        };
    }
};

/**
 * @description 倒计时转化时间
 * @param {number} second 秒数
 * @param {function} cb 回掉函数
 */
let countDownConversion = (second, cb) => {
    if (second <= 0 || typeof parseInt(second) !== "number") {
        cb("00:00:00", true);
        return;
    }
    var timeId = null;
    var isEnd = second <= 0 ? true : false;
    var hour = Math.floor(second / 3600);
    var minute = Math.floor((second % 3600) / 60);
    var seconds = (second % 3600) % 60;
    var dateSting =
        "" +
        addingZero(hour) +
        ":" +
        addingZero(minute) +
        ":" +
        addingZero(seconds) +
        "";
    cb(dateSting, isEnd);
    timeId = window.setInterval(function() {
        second--;
        isEnd = second <= 0 ? true : false;
        hour = Math.floor(second / 3600);
        minute = Math.floor((second % 3600) / 60);
        seconds = (second % 3600) % 60;
        dateSting =
            "" +
            addingZero(hour) +
            ":" +
            addingZero(minute) +
            ":" +
            addingZero(seconds) +
            "";
        cb(dateSting, isEnd);
        if (isEnd) {
            window.clearInterval(timeId);
        }
    }, 1000);

    function addingZero(value) {
        var result = value >= 10 ? value : "0" + value;
        return result;
    }
};

/**
 *
 * @param {string} str
 * @description 去除空格
 */
let trim = (str) => {
    if (typeof str !== "string") return;
    return str.replace(/(^\s+)|(\s+$)/g, "");
};

/**
 * @description 是否pc浏览器
 */
function isPcBrowser() {
    var userAgentInfo = window.navigator.userAgent;
    var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

/**
 * @description 加密手机号
 */
let cryptographicPhone = (phone) => {
    const reg = /^(\d{3})\d{4}(\d{4})$/;
    return phone.replace(reg, "$1****$2");
};

export default {
    debounce: debounce,
    countDown: countDown,
    addSelectStatus: addSelectStatus,
    calc: calc,
    getPriceRange: getPriceRange,
    correctedPcs: correctedPcs,
    countDownConversion: countDownConversion,
    trim: trim,
    isPcBrowser: isPcBrowser,
    cryptographicPhone: cryptographicPhone,
    getRangePriceIndex: getRangePriceIndex,
};
